import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatListModule,
    MatToolbarModule,
    MatProgressBarModule,
    MatChipsModule,
    MatDatepickerModule,
    MatTooltipModule,
    MatProgressSpinnerModule
} from '@angular/material';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { FlexLayoutModule } from '@angular/flex-layout';

import { KsNavigationModule } from '../../shared/ks-navigation/ks-navigation.module';

import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { LoginPageComponent } from './components/login-page/login-page.component';
import { LoginSelectPageComponent } from './components/login-select-page/login-select-page.component';
import { CallbackComponent } from './components/callback/callback.component';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule, MatInputModule, MatSelectModule, MatCheckboxModule, MatFormFieldModule, MatIconModule, MatListModule, MatToolbarModule, MatProgressBarModule, MatChipsModule,
        MatDatepickerModule, MatTooltipModule, MatProgressSpinnerModule,
        MatMomentDateModule,

        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        HttpClientModule,
        TranslateModule, // See app.module for loader
        RouterModule,

        KsNavigationModule
    ],
    declarations: [
        LandingPageComponent,
        LoginPageComponent,
        LoginSelectPageComponent,
        CallbackComponent
    ],
    exports: [
        LandingPageComponent,
        LoginPageComponent,
        LoginSelectPageComponent,
        CallbackComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BaseModule {
}
